import { render } from "./order-actions.vue?vue&type=template&id=2d183bee"
import script from "./order-actions.vue?vue&type=script&lang=js"
export * from "./order-actions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__